const initBioList = () => {
  const bioContainer = document.querySelector('.bio__container--list');

  if (bioContainer) {
    const bioButtons = bioContainer.querySelectorAll('.icon-bio-button');
    bioButtons.forEach((button) => {
      button.addEventListener('click', function (event) {
        const bioID = button.getAttribute('data-id');
        const bioContent = document.querySelector(
          '.bio-content[data-id="' + bioID + '"]',
        );

        bioContent.classList.toggle('bio-content--open');

        if (bioContent.classList.contains('bio-content--open')) {
          document.querySelector(
            '.bio__container--list-card[data-id="' +
              bioID +
              '"] .icon-open-bio',
          ).style.display = 'none';
          document.querySelector(
            '.bio__container--list-card[data-id="' +
              bioID +
              '"] .icon-close-bio',
          ).style.display = 'block';
        } else {
          document.querySelector(
            '.bio__container--list-card[data-id="' +
              bioID +
              '"] .icon-open-bio',
          ).style.display = 'block';
          document.querySelector(
            '.bio__container--list-card[data-id="' +
              bioID +
              '"] .icon-close-bio',
          ).style.display = 'none';
        }
      });
    });
  }
};

export default initBioList;
